export enum QuestionTypeEnum {
  questionAnswerEnum = 10,
  matrixEnum = 20,
  matrixHeaderAnswerEnum = 30,
  dropdownAnswerEnum = 40,
  ratingAnswerEnum = 50,
  openEndedAnswerEnum = 60,
}
